import { render, staticRenderFns } from "./CancelGiPartial.vue?vue&type=template&id=4cc7b485&scoped=true&"
import script from "./CancelGiPartial.vue?vue&type=script&lang=js&"
export * from "./CancelGiPartial.vue?vue&type=script&lang=js&"
import style0 from "./CancelGiPartial.vue?vue&type=style&index=0&id=4cc7b485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc7b485",
  null
  
)

export default component.exports